export default __webpack_public_path__ + "static/media/flag-chile.f3470371.svg";